module.exports = __webpack_public_path__ + "static/okunsanya-80cda6f206f0a652865c1e7966d8fc6a.png";